export const getProps = (_, props) => props;

/**
 * @param {any} state
 * @returns {import("../reducer").NotificationReducer}
 */
export const getRoot = state => state;
export const getState = state => state?.notifications;
